export interface Step1DetectOnPeriodsRequest {
  installation: number
  target_time: string
}

export interface Step1DetectOnPeriodsResponse {
  on_periods: Array<[string, string]>
  selected_start: string
  selected_end: string
}

export interface Step1FallbackDetectOnPeriodRequest {
  installation: number
}

export interface Step2ValidateCycleRequest {
  installation: number
  on_start: string
  on_end: string
  window_minutes?: number
}

export interface Step2ValidateCycleResponse {
  cycle_duration_minutes: number
  mode_check_passed: boolean
}

export interface Step3ExtractFeaturesRequest {
  installation: number
  on_start: string
  on_end: string
  window_minutes?: number
}

export interface Step3ExtractFeaturesResponse {
  features: Array<Record<string, unknown>>
  feature_count: number
}

export interface Step4PredictRequest {
  features: Array<Record<string, unknown>>
}

export enum ChargeCategory {
  CRITICAL_LOW = "CRITICAL_LOW",
  LOW = "LOW",
  NORMAL = "NORMAL",
  CRITICAL_HIGH = "CRITICAL_HIGH"
}

export const CHARGE_CATEGORY_COLORS: Record<ChargeCategory, string> = {
  [ChargeCategory.CRITICAL_LOW]: "#FF2C2C",
  [ChargeCategory.LOW]: "#FF2C2C",
  [ChargeCategory.NORMAL]: "#25c522",
  [ChargeCategory.CRITICAL_HIGH]: "#FF9733"
}

export const CHARGE_CATEGORY_LABELS: Record<ChargeCategory, string> = {
  [ChargeCategory.CRITICAL_LOW]: "Critically undercharged",
  [ChargeCategory.LOW]: "Low",
  [ChargeCategory.NORMAL]: "Normal",
  [ChargeCategory.CRITICAL_HIGH]: "Critically overcharged"
}

export const CHARGE_CATEGORY_DESCRIPTIONS: Record<ChargeCategory, string> = {
  [ChargeCategory.CRITICAL_LOW]: "Sensor data suggests that your equipment is critically undercharged and requires immediate attention.",
  [ChargeCategory.LOW]: "Your equipment appears to be undercharged and may benefit from additional refrigerant.",
  [ChargeCategory.NORMAL]: "Sensor data suggests that your equipment is operating at optimal charge levels.",
  [ChargeCategory.CRITICAL_HIGH]: "Your equipment appears to be critically overcharged and requires immediate attention."
}

export interface ChargeCategoryThreshold {
  category: ChargeCategory;
  max_percent?: number;
}

export interface Step4PredictResponse {
  charge_percent: number
  category: ChargeCategory
  all_thresholds: ChargeCategoryThreshold[];
}

export interface ErrorResponse {
  error: string
}

export interface ChargeDetectionFeedbackRequest {
  installation: number
  analyzed_on_period_start: string
  analyzed_on_period_stop: string
  predicted_charge: number
  rating: 'underestimated' | 'accurate' | 'overestimated'
  extracted_features?: Array<Record<string, unknown>>
  last_charge_date?: string
  last_charge_time?: string
  last_charge_amount?: string
}

export interface ChargeDetectionFeedbackResponse {
  id: number
  installation: number
  analyzed_on_period_start: string
  analyzed_on_period_stop: string
  predicted_charge: number
  rating: string
  last_charge_date?: string
  last_charge_time?: string
  last_charge_amount?: string
  created_at: string
}

export type FeedbackRating = 'underestimated' | 'accurate' | 'overestimated'